// local
import Api from '.';

// Pending
export function savePendingDelivery(data) {
    return Api.post('/delivery/save-pending', data);
}

export function listPendingDelivery() {
    return Api.get('/delivery/list-pending');
}

// Confirm
export function listConfirmDelivery() {
    return Api.get('/delivery/list-confirm');
}

export function confirmPendingDelivery(data) {
    return Api.post('/delivery/confirm-pending', data);
}

export function listConfirmEdit(data) {
    return Api.post('/delivery/list-confirm-edit', data);
}

export function saveConfirmEdit(data) {
    return Api.post('/delivery/save-confirm-edit', data);
}
